import _decorate from "@babel/runtime/helpers/esm/decorate";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { html, property, svg } from 'lit-element';
import { KatLitElement, register } from '../shared/base';
import { isPageDirectionRightToLeft, offHtmlDirChange, onHtmlDirChange } from '../utils/rtl-utils';
import baseStyles from "../shared/base/base.lit.css.js";
import { ifNotNull } from '../utils/directives';
import { NAME_TO_CODE_POINT } from './name-to-code-point';
import { NAME_TO_CODE_POINT_FOR_RTL } from './name-to-code-point-rtl';
import { iconsToFlipHorizantly } from './icons-names-to-flip-horizantly';
import { getFlagUrl } from './name-to-flag';
import _styles from "./icon.lit.css.js";
const stringsFromCodePoints = {};
const customSvgIcons = {
  all_filters: svg`<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9997 16L11.9979 6.66666H9.334L9.33301 15.9998C9.7446 15.8727 10.1946 15.8027 10.666 15.8027C11.1377 15.8027 11.5879 15.8728 11.9997 16ZM11.9979 25.3333L11.9997 21.3333C11.5879 21.4632 11.1377 21.5347 10.666 21.5347C10.1946 21.5347 9.7446 21.4633 9.33301 21.3336L9.334 25.3333H11.9979Z" fill="none"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.667 18.6667C14.667 16.4575 12.8761 14.6667 10.667 14.6667C8.45785 14.6667 6.66699 16.4575 6.66699 18.6667C6.66699 20.8758 8.45785 22.6667 10.667 22.6667C12.8761 22.6667 14.667 20.8758 14.667 18.6667ZM8.66699 18.6667C8.66699 17.5621 9.56242 16.6667 10.667 16.6667C11.7716 16.6667 12.667 17.5621 12.667 18.6667C12.667 19.7712 11.7716 20.6667 10.667 20.6667C9.56242 20.6667 8.66699 19.7712 8.66699 18.6667Z" fill="none"/><path fill-rule="evenodd" clip-rule="evenodd" d="M20.0003 16L20.0021 25.3333L22.666 25.3333L22.667 16.0002C22.2554 16.1273 21.8054 16.1973 21.334 16.1973C20.8623 16.1973 20.4121 16.1272 20.0003 16ZM20.0021 6.66668L20.0003 10.6667C20.4121 10.5368 20.8623 10.4653 21.334 10.4653C21.8054 10.4653 22.2554 10.5367 22.667 10.6664L22.666 6.66668L20.0021 6.66668Z" fill="none"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.333 13.3333C17.333 15.5425 19.1239 17.3333 21.333 17.3333C23.5421 17.3333 25.333 15.5425 25.333 13.3333C25.333 11.1242 23.5421 9.33334 21.333 9.33334C19.1239 9.33334 17.333 11.1242 17.333 13.3333ZM23.333 13.3333C23.333 14.4379 22.4376 15.3333 21.333 15.3333C20.2284 15.3333 19.333 14.4379 19.333 13.3333C19.333 12.2288 20.2284 11.3333 21.333 11.3333C22.4376 11.3333 23.333 12.2288 23.333 13.3333Z" fill="none"/>`,
  unsorted: svg`<path d="M16 12L17.5667 13.5667L21.1111 10.0333V26.2222H23.3333V10.0333L26.8667 13.5778L28.4444 12L22.2222 5.77777L16 12Z" fill="none"/><path d="M16.4443 20L14.8777 18.4333L11.3332 21.9666L11.3332 5.77776L9.111 5.77776L9.111 21.9666L5.57767 18.4222L3.99989 20L10.2221 26.2222L16.4443 20Z" fill="none"/>`,
  expand: svg`<path d="M17.3846 21L16.3 19.825L19.0609 16.834L14 16.8333V15.1667L19.0618 15.167L16.3 12.175L17.3846 11L22 16L17.3846 21Z" fill="none"/><path d="M12.67 21H11V11H12.67V21Z" fill="none"/>`,
  sparkle: svg`<g clip-path="url(#clip0_4067_12142)"><path d="M25.452 12.6924L27.3961 8.44167L31.6731 6.50948L27.3961 4.57731L25.452 0.326538L23.5079 4.57731L19.2309 6.50948L23.5079 8.44167L25.452 12.6924ZM16.6566 15.4433L12.7684 6.94172L8.88023 15.4433L0.326172 19.3076L8.88023 23.1719L12.7684 31.6735L16.6566 23.1719L25.2107 19.3076L16.6566 15.4433Z" fill="none"/></g><defs><clipPath id="clip0_4067_12142"><rect width="32" height="32" fill="white"/></clipPath></defs>`
};
export let KatIcon = _decorate([register('kat-icon')], function (_initialize, _KatLitElement) {
  class KatIcon extends _KatLitElement {
    constructor(...args) {
      super(...args);
      _initialize(this);
    }
  }
  return {
    F: KatIcon,
    d: [{
      kind: "field",
      decorators: [property()],
      key: "name",
      value: void 0
    }, {
      kind: "field",
      decorators: [property()],
      key: "size",
      value: void 0
    }, {
      kind: "field",
      decorators: [property({
        attribute: 'kat-aria-label'
      })],
      key: "katAriaLabel",
      value: void 0
    }, {
      kind: "get",
      static: true,
      key: "styles",
      value: function styles() {
        return [baseStyles, _styles];
      }
    }, {
      kind: "method",
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(KatIcon.prototype), "connectedCallback", this).call(this);
        onHtmlDirChange(this._rerender);
      }
    }, {
      kind: "method",
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(KatIcon.prototype), "disconnectedCallback", this).call(this);
        offHtmlDirChange(this._rerender);
      }
    }, {
      kind: "field",
      key: "_rerender",
      value() {
        return () => {
          this.requestUpdate();
        };
      }
    }, {
      kind: "field",
      key: "_getSizeSelf",
      value() {
        return () => {
          const computedStyle = getComputedStyle(this);
          const height = computedStyle.getPropertyValue('--kat-icon-size') || computedStyle.getPropertyValue('--kat-icon-size-large');
          if (height === '') {
            return null;
          }
          return height;
        };
      }
    }, {
      kind: "method",
      key: "_getAriaHidden",
      value: function _getAriaHidden() {
        return ifNotNull(!this.katAriaLabel ? 'true' : null);
      }
    }, {
      kind: "method",
      key: "_getAriaLabel",
      value: function _getAriaLabel() {
        return ifNotNull(this.katAriaLabel);
      }
    }, {
      kind: "method",
      key: "_getRole",
      value: function _getRole() {
        return ifNotNull(this.katAriaLabel ? 'img' : null);
      }
    }, {
      kind: "method",
      key: "render",
      value: function render() {
        const name = this.name;
        const isRTL = isPageDirectionRightToLeft();
        if (!name) {
          return html``;
        }
        if (name.indexOf('flag-') !== -1) {
          const flagUrl = getFlagUrl(name);
          if (!flagUrl) {
            return html``;
          }
          return html`<img src="${flagUrl}" aria-hidden="${this._getAriaHidden()}" aria-label="${this._getAriaLabel()}">`;
        }
        if (customSvgIcons[name]) {
          return html` <svg height="${ifNotNull(this._getSizeSelf())}" role="${this._getRole()}" aria-hidden="${this._getAriaHidden()}" aria-label="${this._getAriaLabel()}" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> ${customSvgIcons[name]} </svg> `;
        }
        let codePoint = NAME_TO_CODE_POINT[name];
        if (!codePoint) {
          return html``;
        }
        let flipped = false;
        if (isRTL) {
          const rtlCodePoint = NAME_TO_CODE_POINT_FOR_RTL[name];
          if (rtlCodePoint) {
            codePoint = rtlCodePoint;
          } else if (iconsToFlipHorizantly.includes(name)) {
            flipped = true;
          }
        }
        let codePointAsString = stringsFromCodePoints[codePoint];
        if (!codePointAsString) {
          codePointAsString = String.fromCodePoint(codePoint);
          stringsFromCodePoints[codePoint] = codePointAsString;
        }
        return html`<i ?flipped="${flipped}" role="${this._getRole()}" aria-hidden="${this._getAriaHidden()}" aria-label="${this._getAriaLabel()}">${codePointAsString}</i>`;
      }
    }]
  };
}, KatLitElement);
//# sourceMappingURL=icon.js.map